export const adConfig = {
  // Web AdSense configuration
  web: {
    clientId: 'ca-pub-YOUR_CLIENT_ID', // Replace with your AdSense client ID
    feedAdSlot: 'feed-ad-slot', // Replace with your AdSense slot ID
    frequency: 5, // Show ad every 5 posts
    offset: 2, // Start showing ads after 2 posts
  },
  
  // iOS AdMob configuration
  ios: {
    appId: 'ca-app-pub-YOUR_APP_ID', // Replace with your AdMob app ID
    feedAdUnitId: 'ca-app-pub-YOUR_UNIT_ID', // Replace with your AdMob unit ID
    frequency: 5,
    offset: 2,
  },
  
  // Android AdMob configuration
  android: {
    appId: 'ca-app-pub-YOUR_APP_ID', // Replace with your AdMob app ID
    feedAdUnitId: 'ca-app-pub-YOUR_UNIT_ID', // Replace with your AdMob unit ID
    frequency: 5,
    offset: 2,
  },

  // Test ad unit IDs for development
  test: {
    ios: {
      feedAdUnitId: 'ca-app-pub-3940256099942544/2934735716',
    },
    android: {
      feedAdUnitId: 'ca-app-pub-3940256099942544/6300978111',
    },
  },
};